import API from "../../../../app/api";

export const aboutUs = async () => {
    const res = await API.get("/pages/about-us");

    if (!res.data?.success) {
        throw new Error(res.data?.message || "Failed to fetch About Us");
    }

    return res.data.data;
};
